<script setup lang="ts">
import brandLogo from '../assets/orphex-dark.webp'

import { useI18n } from '@/shared/i18n'

const { t } = useI18n()
</script>

<template>
  <img
    class="auth-brand-logo block w-auto h-10 object-contain"
    :src="brandLogo"
    :alt="t('common.appName')"
  />
</template>
